import { createContext, useContext, useCallback, useEffect, useMemo, useState } from "react";
import { translations, LANGUAGES } from "@/i18n/translations";

const LangContext = createContext(null);
const KEY = "vaya_lang";

const get = (obj, path) =>
  path.split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem(KEY) || "en");

  useEffect(() => {
    localStorage.setItem(KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => get(translations[lang], path) ?? get(translations.en, path) ?? path,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t, languages: LANGUAGES }), [lang, t]);

  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useI18n = () => useContext(LangContext);
